import React from 'react';
import Layout from '../components/Layout';
import DocsPrivacy from '../components/DocsPrivacy';
import { Typography } from '@mui/material';
import { RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';

/**
 * Privacy policy page
 * @param props
 */
export default function(props: RouteComponentProps<{ lng: string }>) {
  const { t } = useTranslation('translation');
  return (
    <Layout maxWidth="lg" showFooter={false}>
      <Typography variant="h6">{t('privacyPolicy')}</Typography>
      <DocsPrivacy lng={props.match.params.lng} />
    </Layout>
  );
}
